import { render, staticRenderFns } from "./SameAndWonderful.vue?vue&type=template&id=af52d76e&scoped=true"
import script from "./SameAndWonderful.vue?vue&type=script&lang=js"
export * from "./SameAndWonderful.vue?vue&type=script&lang=js"
import style0 from "./SameAndWonderful.vue?vue&type=style&index=0&id=af52d76e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af52d76e",
  null
  
)

export default component.exports